import React from "react";
import moment from "moment";
import "moment/locale/es";
import numeral from "numeral";
import _ from "lodash";
import { Icon } from "antd";
import { formatNumber } from "libphonenumber-js";

moment.locale("es");

const fiscalRegimen = [
  { label: "Persona Física con Actividad Empresarial", value: "612" },
  { label: "Persona Física con Servicios Profesionales", value: "pf_sp" },
  { label: "Persona Física con Arrendamiento", value: "606" },
  {
    label: "Persona Física por el Regímen de Incorporación Fiscal",
    value: "621"
  },
  { label: "Persona Física con Sueldos y Salarios", value: "605" },
  { label: "Persona Física con Dividendos", value: "611" },
  { label: "Persona Física con Intereses", value: "614" },
  { label: "Persona Física con Actividad Primaria", value: "pf_ap" },
  { label: "Persona Física Enajenación de Bienes", value: "607" },
  { label: "No Contribuyente", value: "nc" },
  { label: "Persona Física con Otros", value: "pf_ot" },
  { label: "Persona Moral", value: "pm" }
];

const economicActivity = [
  {
    label:
      "Actividades del gobierno y de organismos internacionales y extraterritoriales",
    value: "93"
  },
  {
    label: "Agricultura, ganadería, aprovechamiento forestal, pesca y caza",
    value: "11"
  },
  { label: "Alquiler de bienes muebles, muebles e intangibles", value: "523" },
  {
    label: "Asociaciones y Organizaciones Religiosas, Políticas y Civiles",
    value: "8132"
  },
  { label: "Asociaciones Sin Fines de Lucro", value: "asfl" },
  { label: "Comercio al por mayor venta extranjero", value: "43e" },
  { label: "Comercio al por mayor venta nacional", value: "43" },
  { label: "Comercio al por menor venta extranjero", value: "46e" },
  { label: "Comercio al por menor venta nacional", value: "46" },
  { label: "Comisionista, agencia de representación y regalias", value: "car" },
  { label: "Construcción", value: "23" },
  { label: "Desarrollo de Nuevas Tecnologías", value: "dnt" },
  { label: "Dirección de corporativos y empresas", value: "55" },
  {
    label:
      "Electricidad, agua y suministro de gas por ductos al consumidor final",
    value: "22"
  },
  { label: "Fabricación, Producción o Elaboración", value: "fpe" },
  { label: "Industrias manufactureras", value: "31" },
  { label: "Información en medios masivos", value: "51" },
  { label: "Minería", value: "21" },
  { label: "Otro no especificado", value: "one" },
  { label: "Servicios de Administración del personal", value: "sap" },
  {
    label:
      "Servicios de alojamiento temporal y de preparación de alimentos y bebidas",
    value: "72"
  },
  {
    label:
      "Servicios de apoyo a los negocios y manejo de desechos y servicios de remediación",
    value: "56"
  },
  { label: "Servicios de salud y de asistencia social", value: "62" },
  {
    label:
      "Servicios de esparcimiento culturales y deportivos, y otros servicios recreativos",
    value: "71"
  },
  { label: "Servicios educativos", value: "61" },
  { label: "Servicios financieros y de seguros", value: "52" },
  { label: "Servicios inmobiliarios", value: "53" },
  { label: "Servicios profesionales, científicos y técnicos", value: "54" },
  { label: "Sin Obligaciones", value: "sob" },
  { label: "Transportes, correos y almacenamiento", value: "48" },
  { label: "Otros servicios excepto actividades del gobierno", value: "81" }
];

const importersList = [
  { label: "No", value: "no", order: 0 },
  { label: "Régimen General", value: "general", order: 1 },
  { label: "Régimen Sectores Específicos - Textil", value: "textil" },
  { label: "Régimen Sectores Específicos - Calzado", value: "calzado" },
  { label: "Régimen Sectores Específicos - Alcohol", value: "alcohol" },
  { label: "Régimen Sectores Específicos - Armamento", value: "armamento" },
  { label: "Régimen Sectores Específicos - Cigarros", value: "cigarros" },
  { label: "Régimen Sectores Específicos - Automotriz", value: "automotriz" },
  { label: "Régimen Sectores Específicos - Gasolinas", value: "gasolinas" },
  { label: "Régimen Sectores Específicos - Otros", value: "otros" }
];

const period = [
  { label: "Enero - Febrero", value: "1" },
  { label: "Marzo - Abril", value: "2" },
  { label: "Mayo - Junio", value: "3" },
  { label: "Julio - Agosto", value: "4" },
  { label: "Septiembre - Octubre", value: "5" },
  { label: "Noviembre - Diciembre", value: "6" }
];

const employees = [
  { label: "1 - 5", value: "less_than_5", order: 0 },
  { label: "6 - 10", value: "less_than_10", order: 1 },
  { label: "11 - 20", value: "less_than_20", order: 2 },
  { label: "21 - 40", value: "less_than_40", order: 3 },
  { label: "41 - 80", value: "less_than_80", order: 4 },
  { label: "81 - 100", value: "less_than_100", order: 5 },
  { label: "100 ó más", value: "more_than_100", order: 6 }
];

const payrollPeriod = [
  { label: "Semanal", value: "semanal" },
  { label: "Catorcenal", value: "catorcenal" },
  { label: "Quincenal", value: "quincenal" },
  { label: "Mensual", value: "mensual" }
];

var cities = [
  { value: "AGS", label: "AGUASCALIENTES" },
  { value: "BC", label: "BAJA CALIFORNIA" },
  { value: "BCS", label: "BAJA CALIFORNIA SUR" },
  { value: "CMP", label: "CAMPECHE" },
  { value: "COA", label: "COAHUILA" },
  { value: "COL", label: "COLIMA" },
  { value: "CHI", label: "CHIHUAHUA" },
  { value: "CHS", label: "CHIAPAS" },
  { value: "CMX", label: "CIUDAD DE MEXICO" },
  { value: "DGO", label: "DURANGO" },
  { value: "GRO", label: "GUERRERO" },
  { value: "GTO", label: "GUANAJUATO" },
  { value: "HGO", label: "HIDALGO" },
  { value: "JAL", label: "JALISCO" },
  { value: "MCH", label: "MICHOACAN" },
  { value: "MEX", label: "ESTADO DE MEXICO" },
  { value: "MOR", label: "MORELOS" },
  { value: "NAY", label: "NAYARIT" },
  { value: "NL", label: "NUEVO LEON" },
  { value: "OAX", label: "OAXACA" },
  { value: "PUE", label: "PUEBLA" },
  { value: "QR", label: "QUINTANA ROO" },
  { value: "QRO", label: "QUERETARO" },
  { value: "SIN", label: "SINALOA" },
  { value: "SLP", label: "SAN LUIS POTOSI" },
  { value: "SON", label: "SONORA" },
  { value: "TAB", label: "TABASCO" },
  { value: "TLX", label: "TLAXCALA" },
  { value: "TMS", label: "TAMAULIPAS" },
  { value: "VER", label: "VERACRUZ" },
  { value: "YUC", label: "YUCATAN" },
  { value: "ZAC", label: "ZACATECAS" }
];

const countries = [{ label: "MÉXICO", value: "mx" }];

const phoneType = [
  { label: "Móvil", value: "mobile" },
  { label: "Trabajo", value: "work" },
  { label: "Local", value: "local" }
];

const fiscalExcercise = () => {
  const options = [];
  for (let index = -5; index < 1; index++) {
    const yearLabel = moment()
      .add(index, "years")
      .format("YYYY");
    const yearValue = moment()
      .add(index, "years")
      .format("YYYY");
    options.push({ label: yearLabel, value: yearValue });
  }
  return options;
};

const societyType = [
  { label: "Sucursal", value: "sucu" },
  { label: "Asociación Civil (A.C.)", value: "asci" },
  { label: "Establecimiento Permanente CON Ingresos", value: "epci" },
  { label: "Establecimiento Permanente SIN Ingresos", value: "epsi" },
  {
    label: "Saciedad Anónima Promotora de inversión (S.A.P.I.)",
    value: "sapi"
  },
  { label: "Sociedad anónima (S. A.)", value: "soan" },
  { label: "Sociedad Civil (S.C.)", value: "soci" },
  { label: "Sociedad de Acciones Simplificadas (S.A.S.)", value: "soas" },
  { label: "Sociedad de responsabilidad limitada (S. de R.L.)", value: "sorl" },
  {
    label: "Sociedad en comandita por acciones (S. en C. por A.)",
    value: "soca"
  },
  { label: "Sociedad en comandita simple (S. en C.)", value: "socs" }
];

const societyInitialCap = [
  { label: "1 - 50,000", value: "less_than_50000", order: 0 },
  { label: "50,001 - 100,000", value: "less_than_100000", order: 1 }
];

const companyLogoType = [
  { label: "Logotipo", value: "logotipo" },
  { label: "Isotipo", value: "isotipo" },
  { label: "Imagotipo", value: "imagotipo" },
  { label: "Isologo", value: "isologo" }
];

const companySiteSectionsCount = [
  { label: "1", value: "one", order: 0 },
  { label: "2", value: "two", order: 1 },
  { label: "3", value: "three", order: 2 },
  { label: "4", value: "four", order: 3 },
  { label: "5 o más", value: "more_five", order: 4 }
];

const companySitePurpose = [
  {
    label: "Desplegar información de productos y servicios",
    value: "products_info",
    order: 0
  },
  { label: "Tienda en línea", value: "shop", order: 1 },
  { label: "Sitio de blog y noticias", value: "blog_news", order: 2 },
  {
    label: "Obtener información de mis consumidores",
    value: "get_info",
    order: 3
  },
  { label: "otros", value: "other", order: 4 }
];

const companySiteActivities = [
  {
    label: "Buscar información detallada de servicios",
    value: "search_info",
    order: 0
  },
  { label: "Tienda en línea", value: "shop", order: 1 },
  {
    label: "Registro e inicio de sesión de usuario",
    value: "signin",
    order: 2
  },
  {
    label: "Dejar información en formulario de contacto",
    value: "contact_form",
    order: 3
  },
  { label: "otros", value: "other", order: 4 }
];

const companySiteContent = [
  { label: "Galería de imágenes", value: "gallery" },
  { label: "Carrusel de elementos", value: "carrousel" },
  { label: "Formulario de contacto", value: "contact_form" },
  { label: "Animaciones dinámicas", value: "animations" },
  { label: "Videos", value: "videos" },
  { label: "Mapas", value: "maps" }
];

const companySiteStatus = [
  { label: "Cuento con un diseño propio", value: "own_design", order: 0 },
  {
    label: "Cuento con un diseño propio pero se puede modificar/mejorar",
    value: "editable_design",
    order: 1
  },
  { label: "Se debe desarrollar el diseño", value: "new_design", order: 2 }
];

const companySize = [
  { label: "micro", value: "micro", order: 0 },
  { label: "pequeña", value: "small", order: 1 },
  { label: "mediana", value: "medium", order: 2 },
  { label: "grande", value: "large", order: 3 }
];

export const getOptions = fieldName => {
  switch (fieldName) {
    case "fiscalRegimen":
      return fiscalRegimen;
    case "economicActivity":
      return economicActivity;
    case "importersList":
      return importersList;
    case "period":
      return period;
    case "employees":
      return employees;
    case "payrollPeriod":
      return payrollPeriod;
    case "fiscalExcercise":
      return fiscalExcercise();
    case "newAddress_city":
      return cities;
    case "newAddress_country":
      return countries;
    case "newContactData_phone_type":
      return phoneType;
    case "societyType":
      return societyType;
    case "societyInitialCap":
      return societyInitialCap;
    case "companyLogoType":
      return companyLogoType;
    case "companySiteSectionsCount":
      return companySiteSectionsCount;
    case "companySitePurpose":
      return companySitePurpose;
    case "companySiteActivities":
      return companySiteActivities;
    case "companySiteContent":
      return companySiteContent;
    case "companySiteStatus":
      return companySiteStatus;
    case "companySize":
      return companySize;
    default:
      return [];
  }
};

export const yearOptions = () => {
  const options = [];
  for (let index = 0; index < 11; index++) {
    const yearLabel = moment()
      .add(index, "years")
      .format("YYYY");
    const yearValue = moment()
      .add(index, "years")
      .format("YY");
    options.push({ label: yearLabel, value: yearValue });
  }
  return options;
};

export const monthOptions = () => {
  const options = [];
  for (let index = 0; index < 12; index++) {
    const monthValue = moment()
      .month(index)
      .format("MM");
    const monthLabel = `${monthValue} - ${moment()
      .month(index)
      .format("MMMM")}`;
    options.push({ label: monthLabel, value: monthValue });
  }
  return options;
};

export const parseKeys = {
  name: "Nombre",
  email: "Email",
  phone_number: "Número de celular",
  sub: "ID",
  id: "ID",
  serviceTitle: "Servicio",
  category: "Categoría",
  createdAt: "Creación",
  updatedAt: "Última Actualización",
  status: "Estatus",
  paid: "Pagado",
  amount: "Precio",
  discount: "Descuento",
  origin: "Origen de la orden",
  allianceTicket: "Ticket de compra",
  partnerAssignedId: "Asignado"
};

export const parseValues = (key, value) => {
  switch (key) {
    case "createdAt":
    case "updatedAt":
      return moment(value).format("LLL");
    case "amount":
    case "discount":
      return numeral(value).format("$0,0.00");
    case "status":
      return parseStatus[value].title;
    case "paid":
      return value ? <Icon type="check" /> : <Icon type="exclamation" />;
    case "phone_number":
      return formatNumber(value, "International");
    case "partnerAssignedId":
      return value || "Pendiente";
    case "economicActivity":
      if (value && _.find(economicActivity, ["value", value])) {
        return _.find(economicActivity, ["value", value]).label;
      }
      return value;
    case "fiscalRegimen":
      return value && _.find(fiscalRegimen, ["value", value]).label;
    case "importersList":
      return value && _.find(importersList, ["value", value]).label;
    case "period":
      return value && _.find(period, ["value", value]).label;
    case "employees":
      return value && _.find(employees, ["value", value]).label;
    case "payrollPeriod":
      return value && _.find(payrollPeriod, ["value", value]).label;
    case "societyType":
      return value && _.find(societyType, ["value", value]).label;
    case "societyInitialCap":
      return value && _.find(societyInitialCap, ["value", value]).label;
    case "companyLogoType":
      return value && _.find(companyLogoType, ["value", value]).label;
    case "companySiteSectionsCount":
      return value && _.find(companySiteSectionsCount, ["value", value]).label;
    case "companySitePurpose":
      return value && _.find(companySitePurpose, ["value", value]).label;
    case "companySiteActivities":
      return value && _.find(companySiteActivities, ["value", value]).label;
    case "companySiteContent":
      //   return value && _.find(companySiteContent, ["value", value]).label;
      return (
        value &&
        _.join(
          _.map(
            value,
            item => _.find(companySiteContent, ["value", item]).label
          ),
          ", "
        )
      );
    case "companySiteStatus":
      return value && _.find(companySiteStatus, ["value", value]).label;
    case "companySize":
      return value && _.find(companySize, ["value", value]).label;
    default:
      return value;
  }
};

export const parseStatus = {
  created: {
    title: "Creado",
    description:
      "Tu orden se ha generado con éxito, continua con tu proceso para enviar los datos necesarios."
  },
  collectingData: {
    title: "Recopilando datos",
    description:
      "Los datos de tu orden se estan guardando continuamente, lo que te permite tener tu información en todo momento."
  },
  validatingData: {
    title: "Validando datos",
    description:
      "La información de tu orden se ha enviado con exito a uno de nuestros expertos, pronto recibiras una respuesta."
  },
  inProcess: {
    title: "En proceso",
    description:
      "Tu orden se ha asignado a un experto y esta trabajando en tu orden."
  },
  sent: {
    title: "Enviado",
    description:
      "El experto ha enviado una respuesta, revisa tu orden para verificar que todo este correcto y termines el proceso."
  },
  completed: {
    title: "Completado",
    description:
      "Tu orden ha finalizado con éxito, muchas gracias por elegir AS Xpert."
  },
  canceled: {
    title: "Cancelado",
    description: "Has cancelado tu orden."
  }
};



// WEBPACK FOOTER //
// ./src/Utils/catalogues.js